import PackageData from './PackageData';
import { usePackagesContext } from '../../../context/packages_context';
import MiniLoader from '../../../utils/MIniLoader';
import EmptyData from '../../EmptyData';


const YearlyPackages = () => {

    const {
        yearlyPackagesLoading, allYearlyPackages,
    } = usePackagesContext();

    return (
        <>
            <div className="d-flex justify-content-center">
                <MiniLoader
                    load={yearlyPackagesLoading}
                />
            </div>
            <EmptyData
                data={allYearlyPackages}
                title='Packages'
            />

            <div className="row my-5">
                <PackageData
                    allPackages={allYearlyPackages}
                />
            </div>

        </>
    );
};

export default YearlyPackages;